import React, { useState, useEffect } from "react";
import axios from "axios";
import Skeleton from "@mui/material/Skeleton";
import TextField from "@mui/material/TextField";
//
import { validate } from "../../login/validate";
// componets
import AlertSuccess from "../../../components/AlertSuccess/AlertSuccess";
// config
import configData from "../../../config/config.json";
//
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const PassPage = (props) => {
  const { OldPassword, infoApiCome } = props;
  //
  const [passErr, setPassErr] = useState(false);
  // btn disable
  const [disable, setDisable] = useState(false);
  // info data
  const [passData, setPassData] = useState({
    OldPassword: "",
    NewPassword: "",
    RepeatNewPassword: "",
  });
  const passInputHandler = (event) => {
    setPassErr(false);
    setPassData({ ...passData, [event.target.name]: event.target.value });
  };

  //   for success alert
  const [showAlert, setshowAlert] = useState(false);
  const alertHandeler = () => {
    setshowAlert(true);
    setTimeout(() => {
      // After 3 seconds set the show value to false
      setshowAlert(false);
    }, 4000);
  };

  // for validation error
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  useEffect(() => {
    setErrors(validate(passData, "business-setting-pass"));
  }, [passData, touched]);

  const [apiError, setApiError] = useState([]);

  //api header
  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Authorization: "Bearer " + getCookie("token"),
  };

  //   submit btn
  const submitHandler = (event) => {
    event.preventDefault();
    setApiError([]);

    if (!OldPassword) {
      if (
        errors.NewPassword == undefined &&
        errors.RepeatNewPassword == undefined
      ) {
        if (
          passData.NewPassword !== "" &&
          passData.RepeatNewPassword !== ""
          //  &&  passData.OldPassword !== ""
        ) {
          setPassErr(false);

          if (passData.NewPassword !== passData.RepeatNewPassword) {
            setPassErr(true);
          } else {
            setDisable(true);

            const dataPost = {
              password: passData.OldPassword,
              newPassword: passData.NewPassword,
            };

            axios
              .post(
                configData.API_DOMAIN +
                  "/api/v1/BusinessOwners/update-password",
                dataPost,
                {
                  headers: header,
                }
              )
              .then((response) => {
                setDisable(false);
                if (response.data.isSuccess) {
                  // success
                  alertHandeler();
                } else {
                  setApiError(response.data.message);
                }
              });
          }
        }
      } else {
        setTouched({
          NewPassword: true,
          RepeatNewPassword: true,
        });
      }
    } else {
      if (!Object.keys(errors).length) {
        if (
          passData.NewPassword !== "" &&
          passData.RepeatNewPassword !== ""
          //  &&  passData.OldPassword !== ""
        ) {
          setPassErr(false);

          if (passData.NewPassword !== passData.RepeatNewPassword) {
            setPassErr(true);
          } else {
            setDisable(true);

            const dataPost = {
              password: passData.OldPassword,
              newPassword: passData.NewPassword,
            };

            axios
              .post(
                configData.API_DOMAIN +
                  "/api/v1/BusinessOwners/update-password",
                dataPost,
                {
                  headers: header,
                }
              )
              .then((response) => {
                setDisable(false);
                if (response.data.isSuccess) {
                  // success
                  alertHandeler();
                } else {
                  setApiError(response.data.message);
                }
              });
          }
        }
      } else {
        setTouched({
          OldPassword: true,
          NewPassword: true,
          RepeatNewPassword: true,
        });
      }
    }
  };

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  // for password btn icon
  const [showPassword3, setShowPassword3] = React.useState(false);
  const handleClickShowPassword3 = () => setShowPassword3((show) => !show);
  const handleMouseDownPassword3 = (event) => {
    event.preventDefault();
  };
  const [showPassword2, setShowPassword2] = React.useState(false);
  const handleClickShowPassword2 = () => setShowPassword2((show) => !show);
  const handleMouseDownPassword2 = (event) => {
    event.preventDefault();
  };
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <div className="dash-setting-body">
        <h6>رمز عبور</h6>
        <p>
          لطفا رمز عبور جدید را در کادر زیر بنویسید <br className="d-md-none" />
          و دکمه تغییر را بزنید
        </p>
        {OldPassword ? (
          <div className="w-100 max-w-534 mb-2">
            <p className="dash-setting-input-tit mt-0">رمز عبور فعلی</p>
            {infoApiCome ? (
              <div className="position-relative">
                <TextField
                  type={showPassword3 ? "text" : "password"}
                  value={passData.OldPassword}
                  onChange={passInputHandler}
                  name="OldPassword"
                  id="outlined-basic"
                  variant="outlined"
                  className={
                    errors.OldPassword && touched.OldPassword
                      ? "rtl-password-input custom-text-field width-100 mb-2 font-family-en custom-text-field-border-error"
                      : "rtl-password-input custom-text-field width-100 mb-2 font-family-en"
                  }
                  inputProps={{ maxLength: 25 }}
                />
                <IconButton
                  className="show-pass-btn-setting"
                  size="small"
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword3}
                  onMouseDown={handleMouseDownPassword3}
                  edge="start"
                >
                  {showPassword3 ? (
                    <VisibilityOff fontSize="small" />
                  ) : (
                    <Visibility fontSize="small" />
                  )}
                </IconButton>
              </div>
            ) : (
              <Skeleton
                className="mt-n2"
                height={56}
                variant="text"
                animation="wave"
              />
            )}
            {errors.OldPassword && touched.OldPassword && (
              <span className="input-error mx-0 mt-n1">
                {errors.OldPassword}
              </span>
            )}
          </div>
        ) : (
          <></>
        )}

        <div className="w-100 max-w-534 mb-2">
          <p className="dash-setting-input-tit mt-0">رمز عبور جدید</p>
          {infoApiCome ? (
            <div className="position-relative">
              <TextField
                type={showPassword2 ? "text" : "password"}
                value={passData.NewPassword}
                onChange={passInputHandler}
                name="NewPassword"
                id="outlined-basic"
                variant="outlined"
                className={
                  errors.NewPassword && touched.NewPassword
                    ? "rtl-password-input custom-text-field width-100 mb-2 font-family-en custom-text-field-border-error"
                    : "rtl-password-input custom-text-field width-100 mb-2 font-family-en"
                }
                inputProps={{ maxLength: 25 }}
              />
              <IconButton
                className="show-pass-btn-setting"
                size="small"
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword2}
                onMouseDown={handleMouseDownPassword2}
                edge="start"
              >
                {showPassword2 ? (
                  <VisibilityOff fontSize="small" />
                ) : (
                  <Visibility fontSize="small" />
                )}
              </IconButton>
            </div>
          ) : (
            <Skeleton
              className="mt-n2"
              height={56}
              variant="text"
              animation="wave"
            />
          )}
          {errors.NewPassword && touched.NewPassword && (
            <span className="input-error mx-0 mt-n1">{errors.NewPassword}</span>
          )}
        </div>
        <div className="w-100 max-w-534 mb-2">
          <p className="dash-setting-input-tit mt-0">تکرار رمز عبور جدید</p>
          {infoApiCome ? (
            <div className="position-relative">
              <TextField
                type={showPassword ? "text" : "password"}
                value={passData.RepeatNewPassword}
                onChange={passInputHandler}
                name="RepeatNewPassword"
                id="outlined-basic"
                variant="outlined"
                className={
                  errors.RepeatNewPassword && touched.RepeatNewPassword
                    ? "rtl-password-input custom-text-field width-100 mb-2 font-family-en custom-text-field-border-error"
                    : "rtl-password-input custom-text-field width-100 mb-2 font-family-en"
                }
                inputProps={{ maxLength: 25 }}
              />
              <IconButton
                className="show-pass-btn-setting"
                size="small"
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="start"
              >
                {showPassword ? (
                  <VisibilityOff fontSize="small" />
                ) : (
                  <Visibility fontSize="small" />
                )}
              </IconButton>
            </div>
          ) : (
            <Skeleton
              className="mt-n2"
              height={56}
              variant="text"
              animation="wave"
            />
          )}
          {errors.RepeatNewPassword && touched.RepeatNewPassword && (
            <span className="input-error mx-0 mt-n1">
              {errors.RepeatNewPassword}
            </span>
          )}

          {passErr && (
            <div className=" mt-0 input-error mx-0 text-right">
              تکرار رمز عبور مطابقت ندارد.
            </div>
          )}
          {apiError.map((item) => (
            <span className="input-error mx-0">{item}</span>
          ))}
        </div>
        <div className="text-center text-md-start mt-4 mb-3">
          {infoApiCome ? (
            <button
              onClick={submitHandler}
              disabled={disable}
              className="btn_input_business w-210 mb-5"
            >
              ذخیره رمز عبور جدید
            </button>
          ) : (
            <Skeleton
              className="me-md-auto ms-md-0 mx-auto mb-5 mt-5"
              height={56}
              width={200}
              variant="text"
              animation="wave"
            />
          )}
        </div>
      </div>
      {/* alert delete */}
      <AlertSuccess
        showAlert={showAlert}
        text={" رمز عبور جدید با موفقیت ثبت شد."}
      />
    </>
  );
};

export default PassPage;
